
export type AbcIcons = "icon-map-point" | "icon-map" | "icon-map-2" | "icon-maps-eye" | "icon-maps-2" | "icon-flag";
export type AbcIconsNum = "865" | "866" | "867" | "868" | "869" | "845";

export function mapNameIconToChar(iconCss: AbcIcons | undefined): string {
    let icon: string;
    switch (iconCss) {
        case "icon-flag":
            icon = "\ue845";
            break;
        case "icon-map-point":
            icon = "\ue865"
            break;
        case "icon-map":
            icon = "\ue866"
            break;
        case "icon-map-2":
            icon = "\ue867"
            break;
        case "icon-maps-eye":
            icon = "868"
            break;
        case "icon-maps-2":
            icon = "\ue869"
            break;
        default:
            icon = ""
            break;
    }
    return icon;
}
